import { useEffect } from 'react';

/**
 * Bulletproof Scroll Animation Hook.
 * Uses a fail-safe approach: HTML elements are visible by default.
 * Only tags elements as "is-hidden" if they are out of the viewport.
 */
export default function useScrollAnimation() {
  useEffect(() => {
    const timer = setTimeout(() => {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            // If the element is visible in the viewport, remove the hidden tag
            if (entry.isIntersecting) {
              entry.target.classList.remove('is-hidden');
            } else {
              // If it goes out of bounds, add the hidden tag so it can re-animate
              entry.target.classList.add('is-hidden');
            }
          });
        },
        {
          threshold: 0,
          rootMargin: '0px' // Exactly bound to the screen edge
        }
      );

      const elements = document.querySelectorAll('.scroll-animate, .scroll-animate-hero');
      elements.forEach((el) => {
        // Evaluate immediately if the element is inside the viewport right now
        const rect = el.getBoundingClientRect();
        const isInViewport = (
          rect.top < window.innerHeight && rect.bottom > 0
        );

        if (!isInViewport) {
          el.classList.add('is-hidden');
        }
        
        observer.observe(el);
      });

      return () => observer.disconnect();
    }, 100);

    return () => clearTimeout(timer);
  }, []);
}
